module.exports = __webpack_public_path__ + "static/img/img-about-12.7b4a7dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-12.png
// module id = VzAJ
// module chunks = 0